import type { NavigationPanelContextType } from './NavigationPanelContext';

export const projectInitialState = {
    id: '',
    name: '',
    offlineTranslation: false,
    documentProject: false,
    documentOrContentProject: false,
    contentProject: false,
    type: '',
    view: <null | 'single' | 'multi' | 'document'>null,
    search: <null | string>null,
    isBranchingEnabled: false,
    /**
     * 'platforms' is an array of all combinations of platforms present in the project.
     * Every element is a set of binary flags. Use bitwise operations to extract data.
     *
     * For example, to find out if Android platform is present, use:
     * `if (platforms.some(p => Number(p) & 2)) { ... }`
     *
     * Values:
     * - iOS = 1
     * - Android = 2
     * - Web = 4
     * - Other = 16
     *
     * See this thread for more context:
     * https://lokalise.slack.com/archives/C04CW8NJTJ5/p1674758707402799?thread_ts=1674758700.600439&cid=C04CW8NJTJ5
     */
    platforms: [] as string[],
    baseLanguageId: 0,
    baseLanguageLocale: '',
    projectRights: {
        activity: false,
        contributors: false,
        download: false,
        manageKeys: false,
        manageLanguages: false,
        screenshots: false,
        settings: false,
        createBranches: false,
        mergeBranches: false,
        glossary: false,
        manageGlossary: false,
        deleteGlossary: false,
        statistics: false,
        tasks: false,
        workflows: false,
        upload: false,
        review: false,
        modifyMainBranch: false,
        modifyCustomStatus: false,
    },
};

export const badgesInitialState = {
    tasks: null,
    backgroundActivity: null,
};

export const userRightsInitialState = {
    isAdmin: false,
    adminRights: {
        settings: false,
        createBranches: false,
        mergeBranches: false,
    },
};

export const featuresInitialState = {};

export const sessionInitialState = {
    userId: null,
    projectId: null,
    branchId: null,
    fullName: null,
    planId: null,
    email: null,
    planName: undefined,
    trail: {
        daysLeft: 0,
        message: false,
    },
    teamsCount: 1,
    gravatarHash: '',
};

export const branchInitialState = {
    branchId: null,
    branchName: '',
    branchToggle: false,
    list: [],
};

type TeamState = {
    id: string;
    role: 'owner' | 'admin' | 'biller' | 'member';
    admin: boolean;
    name: string;
    owners: number[];
    projects: { id: string; name: string }[];
};

export const teamInitialState: TeamState = {
    id: '',
    role: 'owner',
    admin: false,
    name: '',
    owners: [],
    projects: [],
};

const initialState: NavigationPanelContextType = {
    project: projectInitialState,
    badges: badgesInitialState,
    userRights: userRightsInitialState,
    features: featuresInitialState,
    branch: branchInitialState,
    session: sessionInitialState,
    team: teamInitialState,
};

export default initialState;
